module.exports = __webpack_public_path__ + "static/media/WolfIcon.ada2fb5d.png";